export const de = {
  monitoring: {
    title: 'Monitoring',
    subtitle: 'Health-Checks und Ereignisse',
    healthChecks: {
      cardTitle: 'Health-Checks',
      healthy: 'Healthy',
      unhealthy: 'Unhealthy',
      empty: 'Keine OpenDeskHealthCheck CRs gefunden. Health-Checks werden automatisch erstellt.',
    },
    events: {
      cardTitle: 'Operator-Ereignisse',
      empty: 'Keine Operator-Ereignisse gefunden.',
      table: {
        timestamp: 'Zeitpunkt',
        type: 'Typ',
        reason: 'Grund',
        object: 'Objekt',
        message: 'Nachricht',
      },
    },
  },
  conditionsTable: {
    empty: 'Keine Bedingungen vorhanden.',
    table: {
      type: 'Typ',
      status: 'Status',
      reason: 'Grund',
      message: 'Nachricht',
      timestamp: 'Zeitpunkt',
    },
  },
  stickyActionBar: {
    changeSingular: 'Änderung',
    changePlural: 'Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
    saving: 'Speichern...',
  },
  confirmModal: {
    typePromptPrefix: 'Geben Sie',
    typePromptSuffix: 'ein:',
    cancel: 'Abbrechen',
    delete: 'Löschen',
  },
  dataTable: {
    empty: 'Keine Daten vorhanden.',
  },
  table: {
    rows: 'Zeilen:',
    search: 'Suchen...',
    empty: 'Keine Einträge vorhanden.',
    region: 'Datentabelle',
    pagePrefix: 'Seite',
    pageOf: 'von',
    prevPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
  },
  modal: {
    confirm: 'Bestätigen',
    submit: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    ok: 'OK',
  },
  configSection: {
    unsavedChanges: 'Ungespeicherte Änderungen',
    saving: 'Speichert…',
    save: 'Speichern & Reconcile',
  },
  errorState: {
    title: 'Fehler',
    retry: 'Erneut versuchen',
  },
  loadingState: {
    default: 'Laden...',
  },
  refreshButton: {
    label: 'Aktualisieren',
  },
  yamlViewer: {
    editorLabel: 'YAML-Editor',
    viewLabel: 'YAML-Ansicht',
  },
  toast: {
    dismiss: 'Benachrichtigung schließen',
  },
  verticalTabs: {
    categories: 'Konfigurationskategorien',
  },
} as const;

export const en = {
  monitoring: {
    title: 'Monitoring',
    subtitle: 'Health checks and events',
    healthChecks: {
      cardTitle: 'Health checks',
      healthy: 'Healthy',
      unhealthy: 'Unhealthy',
      empty: 'No OpenDeskHealthCheck CRs found. Health checks are created automatically.',
    },
    events: {
      cardTitle: 'Operator events',
      empty: 'No operator events found.',
      table: {
        timestamp: 'Timestamp',
        type: 'Type',
        reason: 'Reason',
        object: 'Object',
        message: 'Message',
      },
    },
  },
  conditionsTable: {
    empty: 'No conditions available.',
    table: {
      type: 'Type',
      status: 'Status',
      reason: 'Reason',
      message: 'Message',
      timestamp: 'Timestamp',
    },
  },
  stickyActionBar: {
    changeSingular: 'change',
    changePlural: 'changes',
    discard: 'Discard',
    save: 'Save',
    saving: 'Saving...',
  },
  confirmModal: {
    typePromptPrefix: 'Type',
    typePromptSuffix: 'to confirm:',
    cancel: 'Cancel',
    delete: 'Delete',
  },
  dataTable: {
    empty: 'No data available.',
  },
  table: {
    rows: 'Rows:',
    search: 'Search...',
    empty: 'No entries available.',
    region: 'Data table',
    pagePrefix: 'Page',
    pageOf: 'of',
    prevPage: 'Previous page',
    nextPage: 'Next page',
  },
  modal: {
    confirm: 'Confirm',
    submit: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    ok: 'OK',
  },
  configSection: {
    unsavedChanges: 'Unsaved changes',
    saving: 'Saving…',
    save: 'Save & reconcile',
  },
  errorState: {
    title: 'Error',
    retry: 'Retry',
  },
  loadingState: {
    default: 'Loading...',
  },
  refreshButton: {
    label: 'Refresh',
  },
  yamlViewer: {
    editorLabel: 'YAML editor',
    viewLabel: 'YAML view',
  },
  toast: {
    dismiss: 'Dismiss notification',
  },
  verticalTabs: {
    categories: 'Configuration categories',
  },
} as const;
